const parseNum = (value) => {
  if (value === null || value === undefined || value === '') {
    return 0;
  }
  if (typeof value === 'number') {
    return value;
  }
  return parseFloat(String(value).replace(',', '.')) || 0;
};

export const totalAtv = ({ rows }) => {
  const total_taxable_vat = rows.reduce(
    (acc, i) => acc + parseNum(i.taxable_vat),
    0,
  );
  const total_receipts = rows.reduce((acc, i) => acc + parseNum(i.receipts), 0);
  let atv = 0;
  if (total_taxable_vat > 0 && total_receipts > 0) {
    atv = total_taxable_vat / total_receipts;
  }
  const matched = atv.toString().match(/^-?\d+(?:\.\d{0,2})?/);
  return matched ? matched[0].replace('.', ',') : '0';
};

export const totalUpt = ({ rows }) => {
  const total_pieces = rows.reduce((acc, i) => acc + parseNum(i.pieces), 0);
  const total_receipts = rows.reduce((acc, i) => acc + parseNum(i.receipts), 0);
  let upt = 0;
  if (total_pieces > 0 && total_receipts > 0) {
    upt = total_pieces / total_receipts;
  }
  const matched = upt.toString().match(/^-?\d+(?:\.\d{0,2})?/);
  return matched ? matched[0].replace('.', ',') : '0';
};

export const totalTaxes = ({ rows }) => {
  const total_taxable = rows.reduce((acc, i) => acc + parseNum(i.taxable), 0);
  const total_taxable_vat = rows.reduce(
    (acc, i) => acc + parseNum(i.taxable_vat),
    0,
  );
  return {
    total_taxable: !isNaN(total_taxable)
      ? total_taxable.toFixed(2).replace('.', ',')
      : '0,00',
    total_taxable_vat: !isNaN(total_taxable_vat)
      ? total_taxable_vat.toFixed(2).replace('.', ',')
      : '0,00',
  };
};

export const totalConv = ({ rows }) => {
  const total_receipts = rows.reduce((acc, i) => acc + parseNum(i.receipts), 0);
  const total_visitors = rows.reduce((acc, i) => acc + parseNum(i.visitors), 0);
  let conv = 0;
  if (total_receipts > 0 && total_visitors > 0) {
    conv = total_receipts / total_visitors;
  }
  const matched = conv.toString().match(/^-?\d+(?:\.\d{0,2})?/);
  return matched ? matched[0].replace('.', ',') : '0';
};

export const totalRec = ({ rows, key }) =>
  rows.reduce((acc, i) => acc + parseNum(i[key]), 0);
